import { render } from "./ZoomControls.vue?vue&type=template&id=2f3f8a09"
import script from "./ZoomControls.vue?vue&type=script&lang=js"
export * from "./ZoomControls.vue?vue&type=script&lang=js"

import "./ZoomControls.vue?vue&type=style&index=0&id=2f3f8a09&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__